var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBioGlimmerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 651 651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-16{fill:none;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-16,.cls-17,.cls-18,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#231815;stroke-width:3px;}.cls-1{stroke-miterlimit:10;}.cls-18,.cls-2{fill:#dcdddd;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_58);}.cls-4{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_42);}.cls-5{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_605);}.cls-6{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_71);}.cls-7{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_61);}.cls-8{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_54);}.cls-9{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_605-2);}.cls-10{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_25);}.cls-11{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_68);}.cls-12{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_25-2);}.cls-13{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_65);}.cls-14{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_12);}.cls-15{stroke:#fff;stroke-width:2px;opacity:0.4;}.cls-17{fill:#efefef;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_58",
    x1: 249.317,
    y1: 519.615,
    x2: 333.607,
    y2: 435.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdd6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#c4cfe9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#d7bad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eca4c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_42",
    x1: 279.344,
    y1: 430.785,
    x2: 326.81,
    y2: 383.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdd6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#bfd7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e0e5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f4edca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf0c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_605",
    x1: 311.906,
    y1: 348.915,
    x2: 384.722,
    y2: 276.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5e089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#f6e19f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#f8e4d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9e5ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_71",
    x1: 311.377,
    y1: 553.135,
    x2: 404.002,
    y2: 460.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eca4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#efb6c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#f6d5c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#fae9c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf0c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_61",
    x1: 304.275,
    y1: 504.042,
    x2: 415.805,
    y2: 392.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94bde5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#c3c5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#e7cbe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4cde0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_54",
    x1: 326.897,
    y1: 488.395,
    x2: 464.587,
    y2: 350.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdd6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#c5d7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#dbdbb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5e089"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_605-2",
    x1: 388.445,
    y1: 532.722,
    x2: 549.54,
    y2: 371.627,
    xlinkHref: "#\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_605"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_25",
    x1: 466.001,
    y1: 454.619,
    x2: 549.263,
    y2: 371.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4cde0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#c8d4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdd6ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_68",
    x1: 441.367,
    y1: 560.045,
    x2: 579.987,
    y2: 421.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcb1d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#c1b6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#dacfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#ede2c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#f7ecc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf0c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_25-2",
    x1: 420.233,
    y1: 316.748,
    x2: 509.315,
    y2: 316.748,
    xlinkHref: "#\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_65",
    x1: 391.883,
    y1: 281.639,
    x2: 473.409,
    y2: 200.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdd6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#d1daca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#e5dda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#f1df91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5e089"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_12",
    x1: 348.772,
    y1: 175.095,
    x2: 409.665,
    y2: 139.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eca4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf0c5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reference"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.5,
    cy: 325.5,
    r: 324
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400,691.17",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.064,690.4",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.382,647.44a323.217,323.217,0,0,0,107.99-218.25",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.132,429.19a323.257,323.257,0,0,0,108.14,218.38",
    transform: "translate(-74.5 -79.968)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Upper_Circle",
    "data-name": "Upper Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Temp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.17,521.447a67.929,67.929,0,0,0,16.681,18.723c6.762,5.184,13.065,7.912,22.128,11.234a362.046,362.046,0,0,0,43.234,12.936,448.006,448.006,0,0,0,52.766,8.171,520.375,520.375,0,0,0,59.915,2.042c11.674-.14,27.312-.365,48-2.383,16.7-1.628,32.182-3.986,46.638-6.808,18.2-3.554,38.657-8.6,58.894-17.7,7.872-3.541,18.786-9.078,25.872-20.766a44.267,44.267,0,0,0,3.745-7.83v55.659A69.71,69.71,0,0,1,577.787,588c-10.659,8.869-21.712,12.525-46.978,17.872-21.225,4.492-33.923,7.18-53.958,9.362-17.992,1.96-31.051,2.331-50.894,2.894-17.439.5-33.672.961-55.829,0-27.766-1.205-48.089-3.9-62.3-5.788-1.959-.26-11.7-1.706-24.511-4.085-10.961-2.035-16.441-3.053-23.319-4.936a172.375,172.375,0,0,1-25.7-9.362c-10.558-4.57-14.4-7.159-17.532-11.234a28.685,28.685,0,0,1-4.936-10.212Q212,546.978,212.17,521.447Z",
    transform: "translate(-74.5 -79.968)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Crystal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.592,570.35c-12.14-1.58-23.64-3.53-34.34-5.8q-20.04-42.15-40.08-84.28-8.745-18.42-17.51-36.83l31.94-73.12,46.35,96.07Q321.762,518.365,328.592,570.35Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.735,418.244q-23.394,24.069-46.787,48.145L268.6,370.32l53.326,27.438Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M367.137,258.514q-3.754,38.923-7.5,77.839l-64.19-3.895Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.642,574.41c-16.09-.78-31.53-2.16-46.05-4.06q-6.825-51.975-13.64-103.96,23.385-24.075,46.78-48.15Q368.2,496.33,374.642,574.41Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M413.612,575.11q-6.195.1-12.49.05-13.485-.1-26.48-.75-6.45-78.075-12.91-156.17l-39.81-20.48Q315.607,381.515,308.9,365t-13.45-32.54l64.19,3.89Q386.627,455.72,413.612,575.11Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M436.8,383.7l-21.07,15.64q7.3,87.645,14.6,175.27-8.265.375-16.72.5-26.985-119.37-53.97-238.76,3.75-38.925,7.49-77.84l23.45,21.83q16.29,15.18,32.58,30.34l20.17,18.77Q440.062,356.585,436.8,383.7Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M508.452,330.55q-20.37,62.88-40.74,125.79c-.03.09-.06.2-.09.3l-13.33,116.33q-11.715,1.08-23.96,1.64-7.305-87.63-14.6-175.27L436.8,383.7l55.35-41.12,16.26-12.08Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M580.4,421.839l-112.687,34.5q20.38-62.9,40.734-125.789Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M580.4,421.84q-13.755,30.045-27.52,60.09-18.585,40.56-37.16,81.12a414.7,414.7,0,0,1-54.6,9.24q-3.39.36-6.83.68l13.33-116.33c.03-.1.06-.21.09-.3Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M509.315,263.466q-8.579,39.544-17.165,79.116L436.8,383.7q3.266-27.122,6.529-54.242l-20.169-18.777L420.233,249.8Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M420.233,249.8l2.925,60.877q-16.283-15.161-32.575-30.337-2.577-26.289-5.145-52.568l67.635-47.995Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "434.815 183.498 345.733 169.832 378.573 99.809 434.815 183.498"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Cup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M260.391,603.244a510.3,510.3,0,0,0,93.737,3.692,490.479,490.479,0,0,0,85.787-11.915,451.284,451.284,0,0,0,114.553-44.595",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M212.509,568.468c19.472,4.182,40.386,7.72,62.64,10.213a645.8,645.8,0,0,0,186.894-6.553",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M432,618.444a260.683,260.683,0,0,0,42.551-9.295,265.431,265.431,0,0,0,43.214-17.686,270,270,0,0,0,71.807-54.7",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 138.012,
    y1: 464.081,
    x2: 138.012,
    y2: 436.861
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "138.012 491.831 138.012 493.671 138.012 493.861"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 515.232,
    y1: 464.621,
    x2: 515.232,
    y2: 435.981
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 515.222,
    y1: 493.601,
    x2: 515.222,
    y2: 490.571
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M589.712,516.83c-.93,18.75-30.18,35.52-73.99,46.22q18.585-40.56,37.16-81.12C576.532,491.66,590.362,503.75,589.712,516.83Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M294.242,564.55c-49.37-10.47-81.73-27.77-81.73-47.72,0-13.85,15.59-26.56,41.65-36.56Q274.217,522.405,294.242,564.55Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M515.722,563.05a414.331,414.331,0,0,1-54.56,9.24h-.04q-3.39.36-6.83.68-11.715,1.08-23.96,1.64-8.265.375-16.72.5-6.195.1-12.49.05-13.485-.1-26.48-.75c-16.09-.78-31.53-2.16-46.05-4.06-12.14-1.58-23.64-3.53-34.34-5.8",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M615.382,575.55c0,.33-.01.67-.03,1.01-1.84,37.09-100.87,67.41-215.1,66.53-116.19-.88-210.86-28.52-214.98-64.11a21.677,21.677,0,0,1-.14-2.42c0-11.81,9.94-22.9,27.38-32.51V571.8c-.03.31-.04.63-.04.94,0,.22.01.44.02.66a1.942,1.942,0,0,0,.02.24c1.94,25.13,85.65,44.75,188.63,45.37,100.19.61,187.06-20.47,188.67-46.27a10.139,10.139,0,0,0-.09-2.2V544.59C606.062,553.8,615.382,564.34,615.382,575.55Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M615.382,575.55v71.89a323.993,323.993,0,0,1-430.11.13V578.98c4.12,35.59,98.79,63.23,214.98,64.11,114.23.88,213.26-29.44,215.1-66.53C615.372,576.22,615.382,575.88,615.382,575.55Z",
    transform: "translate(-74.5 -79.968)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 540.882,
    y1: 495.581,
    x2: 540.882,
    y2: 494.331
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 540.882,
    y1: 567.711,
    x2: 540.882,
    y2: 567.471
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M589.722,570.54a.985.985,0,0,0-.02-.17",
    transform: "translate(-74.5 -79.968)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioGlimmerLogo);
export default __webpack_public_path__ + "static/media/BioGlimmer LOGO.3e1f2cc978852ad7e8264b12a39d00ad.svg";
export { ForwardRef as ReactComponent };